import "./CareerHero.css";
import heroIllustration from "../assets/images/hero-illustration.png.png";

function CareerHero() {
  return (
    <section className="career-hero">
      <div className="career-hero-text">
        <h1>
          Reliable green power.
          <br />
          Built for new India.
        </h1>
      </div>
      <div className="career-hero-illustration">
        <img src={heroIllustration} alt="Renewable energy landscape" />
      </div>
    </section>
  );
}

export default CareerHero;
